import { render, staticRenderFns } from "./addonsForm.vue?vue&type=template&id=3013c6c8&lang=en&"
import script from "./addonsForm.vue?vue&type=script&lang=js&"
export * from "./addonsForm.vue?vue&type=script&lang=js&"
import style0 from "./addonsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports